import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { animatedWebP } from "../../qualifiers/flag.js";
import { animated } from "../../qualifiers/flag.js";
/**
 * @extends SDK.Action
 * @memberOf Actions.Transcode
 * @description Converts a video to an animated webp or gif.
 * The resulting transformation includes format (f_format) and the animated flag (fl_animated).
 * The flag fl_awebp is added only when an animated webp is requested.
 * @see Visit {@link Actions.Transcode|Transcode} for an example
 */

var ToAnimatedAction = /*#__PURE__*/function (_Action) {
  _inherits(ToAnimatedAction, _Action);

  var _super = _createSuper(ToAnimatedAction);

  function ToAnimatedAction() {
    var _this;

    var animatedFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ToAnimatedAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'toAnimated'
    };

    if (animatedFormat.toString() === 'webp') {
      _this.addFlag(animatedWebP());
    }

    _this.addFlag(animated());

    if (animatedFormat) {
      _this.addQualifier(new Qualifier('f', animatedFormat));
    }

    _this._actionModel.animatedFormat = animatedFormat;
    return _this;
  }
  /**
   * @description Sets the time between frames.
   * @param delayValue The time in milliseconds.
   */


  _createClass(ToAnimatedAction, [{
    key: "delay",
    value: function delay(delayValue) {
      this.addQualifier(new Qualifier('dl', delayValue));
      this._actionModel.delay = delayValue;
      return this;
    }
    /**
     * @description Sets the frequency at which the video is sampled.
     * @param sampling As a string (e.g. '2.3s'), samples one frame every 2.3 seconds.<br>As a number (e.g. 20),
     * samples that many equally spaced frames over the duration of the video.
     */

  }, {
    key: "sampling",
    value: function sampling(_sampling) {
      this.addQualifier(new Qualifier('vs', _sampling));
      this._actionModel.sampling = _sampling;
      return this;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var animatedFormat = actionModel.animatedFormat,
          sampling = actionModel.sampling,
          delay = actionModel.delay; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(animatedFormat);
      sampling && result.sampling(sampling);
      delay && result.delay(delay);
      return result;
    }
  }]);

  return ToAnimatedAction;
}(Action);

export default ToAnimatedAction;